import { Membership } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../hooks/react-query/constants';
import { MembershipClientService } from '../../../tools/helpers';

/**
 * One membership by id with its plan embedded. Exported as options so surfaces that only hold a
 * membership id (a filter order, a PM job) share the cache entry.
 */
export const membershipByIdQueryOptions = (membershipId: number) => ({
  queryKey: [queryKeys.memberships.root, 'membershipById', membershipId],
  queryFn: async (): Promise<Membership | null> => {
    // pbsql drops zero-value predicates: id 0 would read the whole table, not nothing.
    if (membershipId <= 0) return null;
    const filter = Membership.create();
    filter.id = membershipId;
    filter.withType = true;
    // The contract decides the derived status and the renewal date.
    filter.withContract = true;
    // Commercial plans carry their name on the instance lines, not the catalog type.
    filter.withLines = true;
    const res = await MembershipClientService.BatchGet(filter);
    return res?.results?.[0] ?? null;
  },
});

export const useMembershipById = (membershipId: number) =>
  useQuery({ ...membershipByIdQueryOptions(membershipId), enabled: membershipId > 0 });
